/**
 * Add-to-cart feedback for app-injected PLP cards (e.g. id="product-card-{productId}").
 * Button shows "Added!" (then restores label) + assertive live region: "{title} added to the cart", cleared after 2s.
 * Uses cart pubsub when available; falls back to fetch /cart/add response.
 */
(function () {
  if (window.__truInjectedProductCardCartFeedbackInit) return;
  window.__truInjectedProductCardCartFeedbackInit = true;

  var CARD_SELECTOR = '[id^="product-card-"]';
  var FEEDBACK_MS = 2000;
  var PENDING_WINDOW_MS = 6000;

  var pendingCard = null;
  var pendingUntil = 0;
  var pendingButton = null;
  var pendingButtonHtml = null;
  var pubsubSubscribed = false;

  function isInjectedCardRoot(el) {
    return el && el.id && typeof el.id === 'string' && el.id.indexOf('product-card-') === 0;
  }

  function findInjectedCardFromNode(node) {
    return node && node.closest ? node.closest(CARD_SELECTOR) : null;
  }

  function getProductTitle(card) {
    var titleEl = card.querySelector('.tru-product-card-title');
    var t = titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
    if (t) return t;
    var img = card.querySelector('img.tru-product-card-image, .tru-product-card-image-container img');
    if (img && img.getAttribute('alt')) return String(img.getAttribute('alt')).trim();
    return '';
  }

  function ensureFeedbackUI(card) {
    if (card.querySelector('[data-tru-injected-cart-live]')) return;

    var live = document.createElement('div');
    live.setAttribute('data-tru-injected-cart-live', '');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'assertive');
    live.setAttribute('aria-atomic', 'true');
    card.insertBefore(live, card.firstChild);
  }

  function showFeedback(card, ctaButton, savedButtonHtml) {
    if (!card || !document.body.contains(card)) return;

    var now = Date.now();
    var last = card.getAttribute('data-tru-feedback-run');
    if (last && now - parseInt(last, 10) < 400) return;
    card.setAttribute('data-tru-feedback-run', String(now));

    ensureFeedbackUI(card);

    var title = getProductTitle(card);
    var message = title ? title + ' added to the cart' : 'Added to the cart';

    var live = card.querySelector('[data-tru-injected-cart-live]');

    if (live) {
      live.textContent = '';
      requestAnimationFrame(function () {
        live.textContent = message;
      });
      setTimeout(function () {
        if (live && document.body.contains(card)) live.textContent = '';
      }, FEEDBACK_MS);
    }

    var btn = ctaButton;
    if (!btn || !document.body.contains(btn)) {
      btn = card.querySelector('.tru-product-card-cta button');
    }
    if (!btn || !savedButtonHtml) return;

    btn.innerHTML = '';
    try {
      var wrap = document.createElement('div');
      wrap.innerHTML = savedButtonHtml;
      var origSpan = wrap.querySelector('span');
      if (origSpan) {
        var newSpan = document.createElement('span');
        newSpan.className = origSpan.className;
        newSpan.textContent = 'Added!';
        btn.appendChild(newSpan);
      } else {
        btn.textContent = 'Added!';
      }
    } catch (err) {
      btn.textContent = 'Added!';
    }

    setTimeout(function () {
      if (btn && document.body.contains(btn)) btn.innerHTML = savedButtonHtml;
    }, FEEDBACK_MS);
  }

  function clearPending() {
    pendingCard = null;
    pendingUntil = 0;
    pendingButton = null;
    pendingButtonHtml = null;
  }

  function setPendingFromCardCta(card, btn) {
    if (!card || !btn || btn.disabled) return;
    pendingCard = card;
    pendingUntil = Date.now() + PENDING_WINDOW_MS;
    pendingButton = btn;
    pendingButtonHtml = btn.innerHTML;
  }

  function onDocumentClickCapture(e) {
    var btn = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!btn || btn.disabled) return;
    if (btn.closest('.tru-product-card-button-wishlist')) return;

    var cta = btn.closest('.tru-product-card-cta');
    if (!cta) return;

    var card = findInjectedCardFromNode(btn);
    if (!card || !isInjectedCardRoot(card)) return;

    setPendingFromCardCta(card, btn);
  }

  document.addEventListener('click', onDocumentClickCapture, true);

  /* Form POST/GET to cart (cart-as-page) may not go through fetch; capture submitter */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM' || !form.closest) return;
      var card = form.closest(CARD_SELECTOR);
      if (!card || !isInjectedCardRoot(card)) return;
      var action = String(form.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/cart/add') === -1 && action.indexOf('cart/add') === -1) return;

      var sub = e.submitter;
      if (sub && sub.tagName === 'BUTTON' && sub.closest('.tru-product-card-cta')) {
        setPendingFromCardCta(card, sub);
        return;
      }
      var fallbackBtn = form.querySelector('.tru-product-card-cta button');
      if (fallbackBtn) setPendingFromCardCta(card, fallbackBtn);
    },
    true
  );

  function flushPendingFeedbackIfAny(event) {
    if (!pendingCard || Date.now() > pendingUntil) {
      clearPending();
      return;
    }
    var src = event && event.source;
    if (src === 'cart-items') return;
    var card = pendingCard;
    var btn = pendingButton;
    var html = pendingButtonHtml;
    clearPending();
    if (document.body.contains(card)) showFeedback(card, btn, html);
  }

  function trySubscribePubsub() {
    if (pubsubSubscribed) return true;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;

    pubsubSubscribed = true;

    subscribe(PUB_SUB_EVENTS.cartError, function () {
      clearPending();
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, flushPendingFeedbackIfAny);

    return true;
  }

  function bootPubsub() {
    trySubscribePubsub();
  }

  bootPubsub();
  document.addEventListener('DOMContentLoaded', bootPubsub);
  document.addEventListener('shopify:section:load', bootPubsub);

  /* Fallback: some apps add to cart without publishing theme pubsub */
  if (!window.__truInjectedProductCardFetchPatched && typeof window.fetch === 'function') {
    window.__truInjectedProductCardFetchPatched = true;
    var originalFetch = window.fetch.bind(window);

    window.fetch = function () {
      var args = arguments;
      return originalFetch.apply(window, args).then(function (response) {
        try {
          var url = '';
          try {
            if (typeof args[0] === 'string') url = args[0];
            else if (args[0] && typeof Request !== 'undefined' && args[0] instanceof Request) url = args[0].url || '';
            else if (args[0] && args[0].url) url = args[0].url;
          } catch (err) {
            url = '';
          }

          var isCartAdd = url.indexOf('/cart/add') !== -1;
          if (!isCartAdd || !pendingCard || !response || !response.ok || typeof response.clone !== 'function') {
            return response;
          }

          var ct = '';
          try {
            ct = (response.headers && response.headers.get && response.headers.get('content-type')) || '';
          } catch (hErr) {
            ct = '';
          }
          ct = String(ct).toLowerCase();

          var respUrl = '';
          try {
            respUrl = String(response.url || url || '').toLowerCase();
          } catch (uErr) {
            respUrl = String(url || '').toLowerCase();
          }

          /* After redirect, cart-as-page often returns HTML from /cart, not JSON from /cart/add */
          var looksLikeCartPage =
            (respUrl.indexOf('/cart') !== -1 && respUrl.indexOf('/cart/add') === -1 && respUrl.indexOf('add.js') === -1) ||
            ct.indexOf('text/html') !== -1;

          function applySuccessFeedback() {
            if (!pendingCard || Date.now() > pendingUntil) return;
            var card = pendingCard;
            var btn = pendingButton;
            var html = pendingButtonHtml;
            clearPending();
            if (document.body.contains(card)) showFeedback(card, btn, html);
          }

          if (looksLikeCartPage) {
            applySuccessFeedback();
            return response;
          }

          response
            .clone()
            .json()
            .then(function (data) {
              if (!pendingCard || Date.now() > pendingUntil) return;
              if (data && data.status) return;
              applySuccessFeedback();
            })
            .catch(function () {});
        } catch (wrapErr) {
          /* Never break callers' fetch chains */
        }

        return response;
      });
    };
  }
})();
